import { horizontalDividerBlock } from '../common'
import { calculateProgressBarWidth } from './metric_assignment_info'
import { type ImpactType } from '~/types/types'

export const handleTheoryOfChange = (tocImpact: ImpactType, locale) => {
  return [
    horizontalDividerBlock(),
    {
      text: 'Impact Strategy',
      width: '*',
      style: ['blueHeader'],
      margin: [0, 0, 0, 0],
    },
    {
      text: 'ImpactNexus uses the Theory of Change (ToC) framework to help companies and partners understand and communicate how their activities create positive, long-term impact.',
      width: '*',
      style: ['message'],
      margin: [0, 10, 0, -5]
    },
    impactStrategyTable(tocImpact),
    {
      text: 'Theory of Change',
      width: '*',
      style: ['blueTextMedium'],
      margin: [0, 10, 0, 0],
    },
    theoryOfChangeTable(tocImpact),
  ]
}

const impactStrategyTable = (_tocImpact: ImpactType) => {
  return {
    layout: 'noBorders',
    margin: [12, 10, 0, 0],
    table: {
      headerRows: 1,
      widths: ['*', '*', '*'],
      body: [
        [
          { text: 'Company vision', style: 'tableHeader', alignment: 'left' },
          { text: 'Problem statement', style: 'tableHeader', alignment: 'left' },
          { text: 'Target group', style: 'tableHeader', alignment: 'left' },
        ],
        [
          { text: _tocImpact.companyVision, style: 'message', alignment: 'left' },
          { text: _tocImpact.problemStatement, style: 'message', alignment: 'left' },
          { text: _tocImpact.targetGroup, style: 'message', alignment: 'left' },
        ],
      ],
    },
  }
}

const theoryOfChangeTable = (_tocImpact: ImpactType) => {
  return {
    layout: 'noBorders',
    margin: [12, 10, 0, 0],
    table: {
      headerRows: 1,
      widths: ['*','*','*','*','*'],
      body: [
        [
          { text: 'Inputs & activities', style: 'tableHeader', alignment: 'left' },
          { text: 'Solutions output', style: 'tableHeader', alignment: 'left' },
          { text: 'Short-term outcomes', style: 'tableHeader', alignment: 'left' },
          { text: 'Long-term impacts', style: 'tableHeader', alignment: 'left' },
          { text: 'Risk & rebound effects', style: 'tableHeader', alignment: 'left' },
        ],
        [
          { text: _tocImpact.inputsActivities, style: 'message', alignment: 'left' },
          { text: _tocImpact.solutionsOutput, style: 'message', alignment: 'left' },
          { text: _tocImpact.shortTermOutcomes, style: 'message', alignment: 'left' },
          { text: _tocImpact.longTermImpacts, style: 'message', alignment: 'left' },
          { text: _tocImpact.riskReboundEffects, style: 'message', alignment: 'left' },
        ],
      ],
    },
  }
}
